<template>
  <div class="">
    <div class="line"></div>
    <div class="footer-container">
      <div class="item font-12 text-000">
        <div class="flex items-center justify-center m-b-20 friend-links">友情链接：
          <div class="m-r-20" @click="toLick('http://www.moe.gov.cn/index.html')">中华人民共和国教育部</div>
          <div class="m-r-20" @click="toLick('https://www.mohrss.gov.cn/')">中华人民共和国人力资源和社会保障部</div>
          <div class="m-r-20" @click="toLick('https://jyt.yn.gov.cn/')">云南省教育厅</div>
          <div class="m-r-20" @click="toLick('https://hrss.yn.gov.cn/index.html')">云南人力资源和社会保障网</div>
          <div class="m-r-20" @click="toLick('https://www.ynwsjkrc.cn/')">云南卫生健康人才网</div>
          <div class="m-r-20" @click="toLick('https://rsj.km.gov.cn/')">昆明市人力资源和社会保障局</div>
          <div class="" @click="toLick('https://www.kmjyrc.com/')">昆明教育人才网</div>
        </div>
        <div class="flex items-center justify-center m-b-20 org-info">
          <div style="margin-right: 40px;">主办：云南省高校人才市场</div>
          <div>地址：昆明市翠湖北路2号</div>
        </div>
        <div class="flex items-center justify-center m-b-20">
          <div>备案号：滇ICP备2026010138号-1</div>
        </div>
        <div class="text-center m-b-20">1366*768分辨率以上，谷歌、火狐、edge、360（非兼容模式）等浏览器</div>
        <div class="text-center">版权所有：云南省高校人才市场，未经许可，本网站包括图像、图标、文字在内的所有数据不得转载</div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "PublicFooter",
  data() {
    return {
    
    };
  },
  methods: {
    toLick(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.line {
  width: 100%;
  height: 10px;
  background: #B91D22;
}

.footer-container {
  width: 100%;
  box-sizing: border-box;
  padding: 40px 0;
  background: #E5E5E5;

  .item {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}

/* 友情链接 */
.friend-links {
  flex-wrap: wrap;
  row-gap: 6px;
  cursor: pointer;
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
  .footer-container {
    padding: 30px 0;

    .item {
      width: 85%;
    }

    .friend-links {

      .m-r-20 {
        margin-right: 12px;
      }
    }
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .footer-container {
    padding: 24px 0;

    .item {
      width: 92%;
      font-size: 13px;

      .m-b-20 {
        margin-bottom: 12px;
      }
    }

    .friend-links {
      justify-content: center;
      text-align: center;
      line-height: 22px;

      .m-r-20 {
        margin-right: 10px;
      }
    }

    /* 主办信息在手机端纵向排列 */
    .org-info {
      flex-direction: column;
      align-items: center !important;
      gap: 6px;

      div[style*="margin-right"] {
        margin-right: 0 !important;
      }
    }
  }
}
</style>
